import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontWeights, Text } from '@calm-web/design-system';

export const Wrapper = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h4',
	weight: FontWeights.Regular,
})<{
	$hasBorder: boolean;
	$alignment?: string;
	$marginBottom?: number;
}>`
	color: ${p => (p.theme.isDark ? palette('white') : palette('gray8'))};
	margin-bottom: ${p => (p.$marginBottom ? `${p.$marginBottom}px` : '40px')};
	text-align: ${p => p.$alignment ?? 'inherit'};

	${p =>
		p.$hasBorder &&
		`
      border-bottom: 1px #c6c6c6 solid;
      padding-bottom: 24px;
  `}
`;
